import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class UsageTrackService extends BaseService {

  constructor(
    protected override http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/usage_tracks`);
  }

  getLoginHistory(userId: string, page: number = 1, limit: number = 50): Observable<any> {
    return this.http.get(`${environment.apiBaseUrl}/usage_tracks/login_history`, {
      params: {
        user_id: userId,
        page: page.toString(),
        limit: limit.toString()
      }
    });
  }
}
